import React from "react"

import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../../core/gd-components/buttons/control-button/control-button-standard"
import ProjectHeaderLocalSettings from "../../local-settings"
import header_toggleIsCompact from "./function/toggle-is-compact"

type Props = {
    className?  : string
}

const debug = false
// const debug = "ToggleSubmenuButton"

export default function ToggleSubmenuButton(props:Props) {
    debug && console.log(debug, 'render')

    const localSettings = new ProjectHeaderLocalSettings()

    const onClick = (e:any) => {
        e.stopPropagation()
        header_toggleIsCompact(gd.projectViews.project.id)
    }

    if (localSettings.isSubmenuCompact(gd.projectViews.project.id)) {
        return (
            <ControlButtonStandard className    = {props.className}
                                   type         = {ControlButtonType.TOP_PANEL_DOWN}
                                   hint         = "Show project menu"
                                   onClick      = {onClick}/>
        )
    } else {
        return (
            <ControlButtonStandard className    = {props.className}
                                   type         = {ControlButtonType.TOP_PANEL_UP}
                                   hint         = "Hide project menu"
                                   onClick      = {onClick}/>
        )
    }


}
